import { Edit, Trash2, Eye, EyeOff } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export const ProfileList = ({ profiles, onEdit, onDelete, onToggleActive }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-burgundy mb-4">
        Profili ({profiles.length})
      </h2>
      {profiles.length === 0 ? (
        <Card>
          <CardContent className="p-8 text-center text-gray-500">
            Nessun profilo presente. Crea il primo profilo.
          </CardContent>
        </Card>
      ) : (
        profiles.map((profile) => (
          <Card key={profile.id} className={`transition-all ${!profile.attivo ? 'opacity-60' : ''}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-xl font-semibold text-burgundy">
                      {profile.nome}
                    </h3>
                    <span className="px-2 py-1 bg-gold/20 text-gold text-sm font-medium rounded">
                      {profile.codice}
                    </span>
                    <span className={`px-2 py-1 text-sm font-medium rounded ${
                      profile.attivo 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {profile.attivo ? 'Attivo' : 'Inattivo'}
                    </span>
                  </div>
                  <div className="flex gap-4 text-sm text-gray-600 mb-3">
                    <span>
                      <strong>Sesso:</strong> {profile.sesso}
                    </span>
                    <span>
                      <strong>Età:</strong> {profile.eta} anni
                    </span>
                    <span>
                      <strong>Fascia:</strong> {profile.fasciaEta}
                    </span>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{profile.bio}</p>
                </div>
                <div className="flex gap-2 ml-4">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onToggleActive(profile)}
                    title={profile.attivo ? 'Disattiva' : 'Attiva'}
                  >
                    {profile.attivo ? <EyeOff size={18} /> : <Eye size={18} />}
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onEdit(profile)}
                    className="text-blue-600 hover:text-blue-700"
                  >
                    <Edit size={18} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onDelete(profile.id)}
                    className="text-red-600 hover:text-red-700"
                  >
                    <Trash2 size={18} />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))
      )}
    </div>
  );
};
